export const WISE_ANGULAR_PATHS = {
  wise: '/dashboard',
  wise_dashboard: '/dashboard',
  create_message: '/create-message',
  edit_message: '/messages',
  connection_wise: '/connection',
  profile_wise: '/profile',
  integrations_wise: '/integrations',
};

const SAFE_NEXT_PATH = /^\/[A-Za-z0-9/_-]+$/;
const BLOCKED_NEXT = new Set(['/login', '/auth/omni-launch', '/omni-launch']);

export const isSafeWiseLaunchUrl = url => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

export const isSafeLaunchNext = path => {
  if (!path || typeof path !== 'string') {
    return false;
  }
  if (!path.startsWith('/') || path.startsWith('//')) {
    return false;
  }
  if (!SAFE_NEXT_PATH.test(path)) {
    return false;
  }
  return !BLOCKED_NEXT.has(path);
};

export const WISE_ROUTE_NAMES = Object.keys(WISE_ANGULAR_PATHS);

export const isWiseDashboardRoute = route => {
  if (!route) {
    return false;
  }
  if (WISE_ROUTE_NAMES.includes(route.name)) {
    return true;
  }
  const path = route.path || '';
  if (path.includes('/settings/wise')) {
    return false;
  }
  return /\/wise(\/|$)/.test(path);
};

export const angularPathForWiseRoute = routeName => {
  return WISE_ANGULAR_PATHS[routeName] || '/dashboard';
};

export const appendLaunchNext = (url, path) => {
  const next = isSafeLaunchNext(path) ? path : '/dashboard';
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('next', next);
    return parsed.toString();
  } catch (error) {
    return url;
  }
};

export const wiseOriginFromLaunchUrl = url => {
  try {
    return new URL(url).origin;
  } catch (error) {
    return '';
  }
};

export const wiseSelectedCompanyKey = accountId =>
  `wiseSelectedCompany:${accountId || ''}`;

export const wiseSelectedUserKey = (accountId, companyId) =>
  `wiseSelectedUser:${accountId || ''}:${companyId || ''}`;

export const pickLaunchCompanyId = (
  companies,
  { requestedId, storedId } = {}
) => {
  const ids = (companies || []).map(company => String(company.id));
  if (requestedId && ids.includes(String(requestedId))) {
    return String(requestedId);
  }
  if (storedId && ids.includes(String(storedId))) {
    return String(storedId);
  }
  if (ids.length === 1) {
    return ids[0];
  }
  return '';
};

export const pickLaunchUserId = (users, { requestedId, storedId } = {}) => {
  const ids = (users || []).map(user => String(user.id));
  if (requestedId && ids.includes(String(requestedId))) {
    return String(requestedId);
  }
  if (storedId && ids.includes(String(storedId))) {
    return String(storedId);
  }
  if (ids.length === 1) {
    return ids[0];
  }
  return '';
};
